<template>
  <div>
      <el-form
        ref="applyFormRef"
        :model="applyForm"
        :rules="applyRules"
        label-width="120px"
        class="apply-form"
        size="small"
      >
        <el-form-item label="企业名称" prop="title">
          <el-input v-model="applyForm.title" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="办公电话"  v-if="storeInfo.type==2">
          <el-input v-model="applyForm.travel_tel" placeholder="例如：0571-123456"></el-input>
        </el-form-item> -->
        <el-form-item label="省市区" prop="district"  >
        <select-city class=""
            :release="true"
            :width="60"
            :order="true"
            :provinceId="applyForm.province*1"
            :cityId="applyForm.city*1"
            :districtId="applyForm.district*1"
            @getCityInfo="getCityInfo"
        />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="applyForm.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用" prop="unity_code">
          <el-input v-model="applyForm.unity_code" placeholder=" 请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="变更原因" prop="reason" v-if="isGroup">
              <el-radio-group v-model="applyForm.reason">
                  <el-radio label="单位名称变更"></el-radio>
                  <el-radio label="营业执照有修改"></el-radio>
                  <el-radio label="人事调动"></el-radio>
                  <el-radio label="手动填写其他原因"></el-radio>
            </el-radio-group>
        </el-form-item>
        <!-- 选中手动填写其他原因 才显示输入框 -->
        <el-form-item 
          label="其他原因详情" 
          prop="otherReason"
          v-if="applyForm.reason.includes('手动填写其他原因')"
        >
          <el-input v-model="applyForm.otherReason" placeholder="请手动填写原因"></el-input>
        </el-form-item>
        <div v-if="applyForm.longitude" class="mb-2 mt-2">
          <div class="map">
            <b-map class="w-100 "
                  suggestId=""
                  eleHeight="300"
                  @onConfirm="point => getCityInfo(point, 'son')"
                  @setStoreTitle="(v)=>this.BasicInfo.title = v"
                  @dragMarker="position"
                  :allowDrag="true"
                  :WheelZoom="true"
                  :markPoint="storePoint"
                  :MapArea="MapArea"/>
          </div>
          <div class="mapEdit">
            <p class="tips">可拖拽标记点修改定位</p>
            <p class="mr-2"><span>经度</span>{{applyForm.longitude}}</p>
            <p><span>纬度</span>{{applyForm.latitude}}</p>
          </div>
        </div>
      </el-form>
  </div>
</template>

<script>
  import BMap from '@/components/BMap/BMap.vue'
 import { mapActions,mapGetters} from 'vuex'
 let shopTimer = null
export default {
  name: 'MaterialInformation',
  components: {BMap},
  props: {
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const checkShopName = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入申请门店名称'))
      clearTimeout(shopTimer)
      shopTimer = setTimeout(async () => {
        try {
          let data={
            title:value,
            type:2, 
            page:1,
            num:10,
          }
          let result = await this.POST_checkStoreTitle(data);
          let existence=result.list.some((item) => {
            return item.title === value;
          })
          let title=this.applyForm.title!=this.formData.title;
          // const res = await this.$axios.post('/pc/Shop/checkRepeat', { title: value })
          if (existence && title) {
            res.data.isRepeat ? callback(new Error('该门店名称已存在，请更换名称')) : callback()
          } else {
            callback()
          }
        } catch (e) {
          callback(new Error('该门店名称已存在，请更换名称'))
        }
      }, 500)
    }
    return {
      basicInfo: {
        province_name: '',
        city_name: '',
        district_name: '',
      },
      applyForm: {
          title: "",           //采购商名称
          travel_tel: "",      //办公电话
          district: "",        //区县编码
          address: "",         //详细地址
          province: "",        //省份编码
          city: "",            //城市编码
          district: "",        //区县编码
          reason: '',          //变更原因
          otherReason: '',     //其他变更原因
          longitude: "",       //经度
          latitude: "",        //纬度
          unity_code: "",    //统一社会信用代码
        },
      lonLatInfo: '',          //经纬度信息
      applyRules: {
        title: [
          { required: true, message: "请输入采购商名称", trigger: "blur" },
          { validator: checkShopName, trigger: "blur" }
        ],
        district: [{ required: true, message: "请选择区县", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        reason: [
          { required: true, message: '请选择变更原因', trigger: 'change' }
        ],
        otherReason: [{ required: true, message: "请输入其他变更原因", trigger: "blur" }],
      }
    };
  },
  computed: {
    ...mapGetters(['isGroup','storeInfo']),
    storePoint () {      //传入给BMap组件的门店经纬度地址信息，默认公司地址
      return [{
          lng: this.applyForm.longitude ? Number(this.applyForm.longitude) : 120.206194,
          lat: this.applyForm.latitude ? Number(this.applyForm.latitude) : 30.291275,
          IconPng: require('../../../../../../public/images/public/icon.png'),
          nid:true
        }]
    },
      MapArea () {     //传入给BMap组件的区域地址信息
        return {
          province: this.basicInfo.province_name,
          city: this.basicInfo.city_name,
          district: this.basicInfo.district_name,
          address: this.applyForm.address
        }
      }
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        // 合并对象只合并第一个存在的key
        this.applyForm = this.$_Object.getMergedObj(this.applyForm, newVal);
        this.basicInfo = this.$_Object.getMergedObj(this.basicInfo, newVal);
        console.log(this.basicInfo)
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_checkStoreTitle']),
    async handleSubmit() {
        return new Promise((resolve, reject) => {
            this.$refs.applyFormRef.validate(valid => {
            if (!valid) {
                // 校验失败，reject
                reject()
                return
            }
            // 校验成功，把表单数据抛出去
            resolve(this.applyForm)
            })
        })
    },
    //获取省市区id
    getCityInfo (info) {
      console.log(info)
      this.basicInfo=info;
      this.applyForm.province = info.province;
      this.applyForm.city = info.city;
      this.applyForm.district = info.district;
    },
    position(e){
      if(!this.lonLatInfo){
        this.lonLatInfo=e;
        return;
      }
      
      this.applyForm.longitude = e.lng; this.applyForm.latitude = e.lat;
    },
  }
};
</script>

<style lang="scss" scoped>
.map{
  border: 6px solid #eee;
  border-radius: 6px;
  overflow: hidden;
}
.mapEdit{
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  margin: 10px auto;
}
.tips{
  margin-right: auto;
}
.mapEdit span{
  display: inline-block;
  background-color: var(--smtc-color-primary);
  color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 5px;
}
</style>
